// extracted by mini-css-extract-plugin
export var colorSquare = "_tl-0";
export var danger = "_tl-5";
export var lightPink = "_tl-8";
export var neutralBlue = "_tl-7";
export var neutralYellow = "_tl-6";
export var normal = "_tl-1";
export var primary = "_tl-2";
export var primaryLight = "_tl-3";
export var solidBlack = "_tl-g";
export var solidGreen = "_tl-b";
export var solidLightBlue = "_tl-d";
export var solidNavy = "_tl-c";
export var solidOrange = "_tl-f";
export var solidPink = "_tl-e";
export var solidRed = "_tl-9";
export var solidYellow = "_tl-a";
export var success = "_tl-4";